"use strict";
/*
 * Created on 23. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var UserMessageConverter_1 = require("./conversions/UserMessageConverter");
/**
 * User messages app module.
 * @author Radek Beran
 */


var UserMessagesAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(UserMessagesAppModule, _AppModule_1$AppModul);

  function UserMessagesAppModule() {
    var _this;

    _classCallCheck(this, UserMessagesAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserMessagesAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'userMessage';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(UserMessagesAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(UserMessageConverter_1.UserMessageConverter).to(UserMessageConverter_1.UserMessageConverter).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return UserMessagesAppModule;
}(AppModule_1.AppModule);

exports.UserMessagesAppModule = UserMessagesAppModule;